import React from 'react'

import AgentPage from '@SonarCX/components/templates/AgentPage'
import NotificationsPage from '@SonarCX/pages/Notifications/Page'

const Notifications = () => {
  const containerRef = React.useRef(null)

  return (
    <AgentPage rootRef={containerRef} scroll centerContent>
      <NotificationsPage rootRef={containerRef} />
    </AgentPage>
  )
}

export default Notifications
